var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{class:[_vm.$style.container, _vm.historyLength > 1 ? _vm.$style.visible : ''],on:{"click":_vm.goBack}},[_c('base-icon',{class:_vm.$style.arrow,attrs:{"name":"arrow-longer-left"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }